import React, { FC } from "react";
import { cn } from "@/lib/utils";
import { Copy } from "lucide-react";

interface InfoFieldProps {
  title: string;
  value: string;
  className?: string;
  copyable?: boolean;
}

export const InfoField: FC<InfoFieldProps> = ({
  title,
  value,
  className,
  copyable,
}) => {
  const handleCopy = (e: any) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
  };

  return (
    <div
      className={cn(
        "flex flex-row items-center justify-between gap-3 overflow-hidden",
        className,
      )}
    >
      <div className="flex shrink-0 items-center gap-1.5 text-sm text-neutral-500">
        {title}
        {copyable && (
          <button
            onClick={handleCopy}
            className="cursor-pointer text-neutral-400 transition-colors hover:text-neutral-600"
          >
            <Copy className="size-3.5" />
          </button>
        )}
      </div>

      <span
        className="text-eathy-comfort-1 min-w-0 text-right text-sm font-medium break-words"
        title={value}
      >
        {value}
      </span>
    </div>
  );
};
